import { createContext } from 'react'
import { defaultState } from './defaultState'

const AlertContext = createContext(defaultState)

export { AlertContext }
